// extracted by mini-css-extract-plugin
export var labels = "ScientistOfTheDayIndex-module--labels--e3f34";
export var letterButton = "ScientistOfTheDayIndex-module--letterButton--21129";
export var links = "ScientistOfTheDayIndex-module--links--4cd2a";
export var scientistOfTheDayIndex = "ScientistOfTheDayIndex-module--scientistOfTheDayIndex--6b2dd";
export var selected = "ScientistOfTheDayIndex-module--selected--556c0";